import * as React from 'react';

const UkrFlag = props => (
  <svg
    data-name="Group 2045"
    id="Group_2045"
    viewBox="0 0 41.108 25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      data-name="Rectangle 454"
      fill="#3876c5"
      height="12.5"
      id="Rectangle_454"
      width="41.108"
    />
    <rect
      data-name="Rectangle 455"
      fill="#f8de0e"
      height="12.5"
      id="Rectangle_455"
      transform="translate(0 12.5)"
      width="41.108"
    />
  </svg>
);

export default UkrFlag;
